import api from './api';

const contractService = {
  getContracts: async (filters = {}) => {
    const response = await api.get('/contracts', { params: filters });
    return response.data;
  },

  getContract: async (id) => {
    const response = await api.get(`/contracts/${id}`);
    return response.data;
  },

  createContract: async (data) => {
    const response = await api.post('/contracts', data);
    return response.data;
  },

  updateContract: async (id, data) => {
    const response = await api.put(`/contracts/${id}`, data);
    return response.data;
  },

  deleteContract: async (id) => {
    const response = await api.delete(`/contracts/${id}`);
    return response.data;
  },
};

export default contractService;
